"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon"));
/**
 * A simple wrapper component to apply icon styles to ListItems.
 */
var ListItemIcon = function ListItemIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, props);
};
ListItemIcon.muiName = 'ListItemIcon';
ListItemIcon.propTypes = {
  /**
   * The content of the component, normally an icon
   */
  children: _propTypes.default.element.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object])
};
var _default = exports.default = ListItemIcon;